'use client';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { MagnifyingGlassXs } from '@lichtblick/photon/icons/objects/magnifying-glass-xs';
import classNames from 'classnames';
import { useRouter } from 'next/navigation';
import styles from './search.module.scss';
export const Search = ()=>{
    const router = useRouter();
    return /*#__PURE__*/ _jsxs("form", {
        action: (formData)=>{
            const rawInputValue = formData.get('search');
            // remove leading/trailing and double spaces
            const sanitizedInputValue = rawInputValue.trim().replace(/\s{2,}/g, ' ');
            router.push(`/suche/${encodeURIComponent(sanitizedInputValue)}/`);
        },
        className: classNames(styles.container),
        children: [
            /*#__PURE__*/ _jsx("input", {
                "aria-label": "Suche",
                autoComplete: "off",
                className: styles.input,
                maxLength: 80,
                minLength: 3,
                name: "search",
                onInvalid: (e)=>{
                    e.preventDefault();
                },
                placeholder: "Suche",
                type: "search"
            }),
            /*#__PURE__*/ _jsx("button", {
                "aria-label": "Suchen",
                className: styles.submit,
                type: "submit",
                children: /*#__PURE__*/ _jsx(MagnifyingGlassXs, {
                    "aria-hidden": true
                })
            })
        ]
    });
};

//# sourceMappingURL=search.js.map